import React, { FC } from 'react';
import { Select } from '@workboard/wobo-ui';
import { getRepeatLabel, Repeat } from './model';
import { useSelectEnumField } from '../form/useSelectEnumField';
import { useTranslation } from 'react-i18next';

interface IProps {
  name: string;
  'data-testid'?: string;
  isDisabled?: boolean;
  helperText?: string;
  isError?: boolean;
  label?: string;
  id?: string;
  onChange(e: React.ChangeEvent, obj: unknown): void;
  value?: Repeat;
}

export const RepeatField: FC<IProps> = ({
  name,
  onChange,
  value,
  ...props
}) => {
  const { t } = useTranslation();
  const customProps = useSelectEnumField(Repeat, name, value, onChange);

  return (
    <Select
      {...props}
      getOptionLabel={(opt) => getRepeatLabel(opt.value, t)}
      label={props.label ?? t('Repeat')}
      name={name}
      {...customProps}
    />
  );
};
